// SpotSnap.jsx
import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faGift } from '@fortawesome/free-solid-svg-icons';
import '../../styles/SpotSnap.css';
import '../../styles/ImageIdentification.css';
import todaysimage from '../../assets/2603202401.png';

const SpotSnap = () => {
    const authState = useSelector(state => state.authReducer);
    const [userName, setUserName] = useState(null);
    const [email, setEmailId] = useState(null);
    const [userID, setUserID] = useState(null);
    const [imageX1, setImageX1] = useState();
    const [imageY1, setImageY1] = useState();
    const [imageX2, setImageX2] = useState();
    const [imageY2, setImageY2] = useState();
    const [answerX, setAnswerX] = useState();
    const [answerY, setAnswerY] = useState();
    const [imageID, setImageID] = useState();
    const [coordinates, setCoordinates] = useState({ x: 0, y: 0 });
    const [spotIdentified, setSpotIdentified] = useState(false);
    const [reloadTime, setReloadTime] = useState(new Date());
    const [submitTime, setSubmitTime] = useState(null);
    const [submitDisabled, setSubmitDisabled] = useState(false);
    const [timeDifference, setTimeDifference] = useState(null);
    const [resultMessage, setResultMessage] = useState("");
    const [timeTakenMessage, setTimetakenMessage] = useState("");
    const [imageDate, setImageDate] = useState(null);
    const [imageDataId, setImageDataId] = useState(null);
    const [imageDesc, setImageDesc] = useState(null);
    const [imageRemarks, setImageRemarks] = useState(null);
    const [imageSponsor, setImageSponsor] = useState(null);
    const [submitting, setSubmitting] = useState(false);

    const fetchData = async () => {
        try {
            if (authState.user) {
                setUserName(authState.user.name || 'none');
                setEmailId(authState.user.email || 'none');
                setUserID(authState.user._id || 'none');
            } else {
                setUserName('none');
                setEmailId('none');
                setUserID('none');
            }

            // Fetch image data
            const userDate = new Date();
            const formattedDate = userDate.toLocaleDateString('en-GB', { day: '2-digit', month: '2-digit', year: 'numeric' }).split('/').reverse().join('-');
            const response = await fetch(`/api/spotsnapmaster/${formattedDate}`);
            if (!response.ok) {
                throw new Error('Failed to fetch image data ID');
            }
            const data = await response.json();
            setImageID(data._id);
            setImageDate(data.date);
            setImageDataId(data.dataId);
            setImageDesc(data.dataDesc);
            setImageRemarks(data.remarks);
            setImageSponsor(data.sponsor);
            setImageX1(data.x1);
            setImageY1(data.y1);
            setImageX2(data.x2);
            setImageY2(data.y2);
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };

    useEffect(() => {
        fetchData();
    }, [authState]);

    const handleClick = (event) => {
        const rect = event.target.getBoundingClientRect();
        const x = event.clientX - rect.left;
        const y = event.clientY - rect.top;
        setCoordinates({ x, y });
        // console.log("bounding (h,w): (" + Math.floor(rect.height) + "," + Math.floor(rect.width) + ") " + "Clicked (x,y): " + Math.floor(x) + "," + Math.floor(y) + ") " + "Correct ((x1,y1)(x2,y2)): (" + imageX1 + "," + imageY1 + ") " + "(" + imageX2 + "," + imageY2 + ")");
        if (event.detail === 2) {
            setSpotIdentified(true);
            setAnswerX(x);
            setAnswerY(y);
        }
    };

    const handleSubmit = async () => {
        try {
            setSubmitDisabled(true);
            setSubmitting(true);
            setSubmitTime(new Date());
            const difference = new Date().getTime() - reloadTime.getTime();
            const hours = Math.floor(difference / (1000 * 60 * 60));
            const minutes = Math.floor((difference % (1000 * 60 * 60)) / (1000 * 60));
            const seconds = Math.floor((difference % (1000 * 60)) / 1000);
            setTimeDifference({ hours, minutes, seconds });

            const bound1 = { x: imageX1, y: imageY1 };
            const bound2 = { x: imageX2, y: imageY2 };
            const isWithinRange = isWithinAnswerBound(coordinates, bound1, bound2);

            setTimetakenMessage(`Time taken: ${hours} hours, ${minutes} minutes, ${seconds} seconds.`);
            let submitstatus = "";
            if (isWithinRange) {
                const spotSnapUserAnswerSaveData = {
                    userID: userID,
                    userName: userName,
                    emailId: email,
                    imageID: imageID,
                    imageDataId: imageDataId,
                    answerX: parseInt(answerX),
                    answerY: parseInt(answerY),
                    imageX1: imageX1,
                    imageY1: imageY1,
                    imageX2: imageX2,
                    imageY2: imageY2,
                    answerStatus: spotIdentified ? 1 : 2,
                    answerDate: new Date().toISOString(),
                    startDateTime: reloadTime.toISOString(),
                    endDateTime: new Date().toISOString(),
                    timeTaken: difference / 1000,
                };
                const config = {
                    url: "/spotsnapsaveanswer",
                    method: "post",
                    data: spotSnapUserAnswerSaveData,
                    headers: { Authorization: authState.token }
                };
                // Fixed: Use fetch directly instead of fetchData(config)
                const response = await fetch(config.url, {
                    method: config.method,
                    headers: {
                        'Content-Type': 'application/json',
                        ...config.headers
                    },
                    body: JSON.stringify(config.data)
                });
                const result = await response.json();
                if (result && result.success && result.message === 1) {
                    submitstatus = "Thank you for your entry. Please check SpotSnap Leaderboard for your result next day.";
                } else {
                    submitstatus = "Sorry, we encountered an issue while processing your request to save SpotSnap answer. Please try again.";
                }
            } else {
                submitstatus = "Your click was not within the correct spot. Please try again.";
            }

            setResultMessage(submitstatus);
        } catch (error) {
            console.error("Error submitting data:", error);
            setResultMessage("Sorry, there was an error processing your request. Please try again later.");
        } finally {
            setSubmitting(false); 
            setSubmitDisabled(true);
        }
    };

    const isWithinAnswerBound = (coordinates, bound1, bound2) => {
        const minX = Math.min(bound1.x, bound2.x);
        const maxX = Math.max(bound1.x, bound2.x);
        const minY = Math.min(bound1.y, bound2.y);
        const maxY = Math.max(bound1.y, bound2.y);

        return (
            coordinates.x >= minX &&
            coordinates.x <= maxX &&
            coordinates.y >= minY &&
            coordinates.y <= maxY
        );
    };

    useEffect(() => {
        if (submitTime && reloadTime) {
            const difference = submitTime.getTime() - reloadTime.getTime();
            const hours = Math.floor(difference / (1000 * 60 * 60));
            const minutes = Math.floor((difference % (1000 * 60 * 60)) / (1000 * 60));
            const seconds = Math.floor((difference % (1000 * 60)) / 1000);
            setTimeDifference({ hours, minutes, seconds });
        }
    }, [submitTime, reloadTime]);

    return (
        <div className="mx-auto px-4 sm:px-8 py-4 bg-gray-900 min-h-screen text-white">
            <div className="border-b border-gray-600 pb-2 mb-4">
                <h2 className="text-xl sm:text-2xl font-bold">SpotSnap</h2>
            </div>

            {imageDesc && (
                <p className="text-base sm:text-lg mb-4 leading-relaxed">
                    {imageDesc}
                </p>
            )}
            {imageRemarks && (
                <p className="text-base sm:text-lg mb-6 text-yellow-400 leading-relaxed">
                    {imageRemarks}
                </p>
            )}

            <div className="flex flex-col items-center w-full max-w-4xl mx-auto">
                <div className="relative w-full bg-gray-800 rounded-lg overflow-hidden shadow-lg">
                    <img
                        id="image-element"
                        src={todaysimage}
                        alt="Today's Image"
                        onClick={handleClick}
                        className="w-full h-auto max-w-full cursor-pointer hover:brightness-105 transition-all block mx-auto"
                    />
                    {spotIdentified && (
                        <div
                            className="absolute w-4 h-4 bg-red-500 rounded-full border-2 border-white shadow-md pointer-events-none -translate-x-1/2 -translate-y-1/2"
                            style={{ left: `${coordinates.x}px`, top: `${coordinates.y}px` }}
                        />
                    )}
                </div>

                {spotIdentified && !timeDifference && (
                    <button
                        onClick={handleSubmit}
                        disabled={submitDisabled || submitting}
                        className="mt-6 w-full sm:w-auto px-8 py-3 bg-green-600 hover:bg-green-700 disabled:bg-green-800 text-white font-semibold rounded-lg shadow-md transition-colors disabled:cursor-not-allowed"
                    >
                        {submitting ? 'Submitting...' : 'Submit'}
                    </button>
                )}

                {timeDifference && (
                    <div className="mt-8 w-full text-center bg-gray-800 p-6 rounded-lg shadow-lg">
                        <h3 className="text-lg sm:text-xl font-semibold mb-4 text-green-400">Thank You! Visit Again.</h3>
                        {resultMessage && (
                            <p className={`mb-4 text-sm sm:text-base ${resultMessage.includes("Sorry") ? 'text-red-400' : 'text-yellow-400'}`}>
                                {resultMessage}
                            </p>
                        )}
                        {timeTakenMessage && (
                            <p className="mb-4 text-sm sm:text-base text-yellow-400 font-medium">
                                {timeTakenMessage}
                            </p>
                        )}
                        <div className="text-sm sm:text-base space-y-2 text-gray-300">
                            <p>Share this fun activity with your family, friends, colleagues, employees, and boss!</p>
                            <p>Don't forget to check the Leaderboard.</p>
                            <p>Check tomorrow if you're among the lucky winners to claim a gift!</p>
                        </div>

                        <div className="mt-6">
                            <div className="border-b border-gray-600 pb-2 mb-4">
                                <h2 className="text-lg sm:text-xl font-bold text-white">SpotSnap Info & Rules</h2>
                            </div>
                            <div className="w-full md:w-7/12 bg-gray-800 p-4 border-2 border-gray-600 shadow-md rounded-lg mx-auto">
                                <div className="flex flex-col justify-center items-center mb-4">
                                    <div className="flex justify-center items-center mb-2">
                                        <FontAwesomeIcon icon={faGift} className="text-yellow-500 text-4xl sm:text-5xl" />
                                    </div>
                                    <div className="flex justify-center items-center">
                                        <p className="text-yellow-500 text-center text-xl sm:text-3xl font-bold">Lucky Winners Will Get A Gift</p>
                                    </div>
                                </div>
                                <div className="text-white text-sm sm:text-base leading-relaxed">
                                    <p className="font-semibold text-lg mb-2">SpotSnap: Find Your Moments</p>
                                    <p className="mb-4">
                                        Transforms image exploration into a daily adventure, uncover hidden treasures and share
                                        the discoveries with friends.
                                    </p>
                                    <p className="mb-4">
                                        With SpotSnap, every click becomes an exciting opportunity to explore the world around
                                        you and find joy in the little things. Whether it's spotting a beautiful sunset,
                                        a quirky street art, or a nostalgic childhood memory, SpotSnap turns everyday moments
                                        into memorable experiences.
                                    </p>
                                    <p className="mb-4">
                                        Join the SpotSnap community and embark on a daily journey of discovery,
                                        one click at a time. Let SpotSnap add a splash of fun and excitement to your day as you
                                        explore, snap, and share your favorite spots with the world.
                                    </p>
                                    <h3 className="font-semibold text-yellow-500 mt-6 text-lg">Your Problem</h3>
                                    <p className="mb-4">
                                        You will see a picture
                                        <br />
                                        And instructions on what is expected
                                    </p>
                                    <h3 className="font-semibold text-yellow-500 mt-6 text-lg">Steps to follow</h3>
                                    <ol className="list-decimal list-inside space-y-1 mb-4 text-sm sm:text-base">
                                        <li className="mb-1">Spot the mistake</li>
                                        <li className="mb-1">Double Clicked</li>
                                        <li className="mb-1">Submit</li>
                                        <li className="mb-1">View Your Spot on SpotSnap Leaderboard</li>
                                        <li className="mb-1">Revisit Next Day and check if you are amongst lucky winners</li>
                                        <li className="mb-1">Claim Your Prize</li>
                                        <li className="mb-1">We will respond within 1 working day</li>
                                    </ol>
                                </div>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};

export default SpotSnap;